<div class="page-wrapper">
  <div class="page-content">
    <div class="page-header">
      <hyperkit-typography variant="h1" align="center" color="primary"
        >Archived Content</hyperkit-typography
      >
      <hyperkit-typography
        variant="body"
        size="md"
        align="center"
        color="secondary"
        >Oops! This content is archived.</hyperkit-typography
      >
    </div>
    <hyperkit-button
      routerLink="/hunt"
      variant="standard"
      color="tertiary"
      text="Back to Hunt Module"
    ></hyperkit-button>
  </div>
</div>
